import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import ContactRescue from './components/ContactRescue';
import EvercontactUsers from './components/EvercontactUsers';
import KnowledgeBase from './components/KnowledgeBase';
import Auth from './components/Auth';
import ChatWidget from './components/ChatWidget';
import { ChatProvider } from './contexts/ChatContext';
import { useAuth } from './hooks/useAuth';

function App() {
  const { user, loading, isAuthenticated } = useAuth();
  const [currentPage, setCurrentPage] = useState('contact-rescue');

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Auth onAuthSuccess={() => window.location.reload()} />;
  }

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'contact-rescue':
        return <ContactRescue />;
      case 'evercontact-users':
        return <EvercontactUsers />;
      case 'knowledge-base':
        return <KnowledgeBase />;
      default:
        return <ContactRescue />;
    }
  };

  return (
    <ChatProvider>
      <div className="App">
        <Header user={user} currentPage={currentPage} onNavigate={setCurrentPage} />
        <main className="main-content">
          {renderCurrentPage()}
        </main>
        <ChatWidget />
      </div>
    </ChatProvider>
  );
}

export default App;